var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('path',{attrs:{"transform":_vm.ringBackgroundTransform,"d":_vm.ringBackgroundPath,"fill":"rgba(0,0,0,0.75)","stroke":"none","filter":_vm.ringBackgroundFilter}})}
var staticRenderFns = []

export { render, staticRenderFns }